import { detectSystemLanguage } from '../config/languages';
import { allTranslations } from './translations/index';

export interface Translation {
  // 侧边栏
  newChat: string;
  search: string;
  user: string;
  settings: string;
  language: string;
  getHelp: string;
  viewAllPlans: string;
  learnMore: string;
  logOut: string;

  // 语言选择器
  chooseLanguage: string;
  chooseYourPreferredLanguage: string;
  searchLanguages: string;
  autoDetect: string;
  noLanguagesFound: string;

  // 聊天区域
  askAnything: string;
  lawhelperAi: string;

  // 用户信息
  personal: string;
  freePlan: string;

  // 通用
  current: string;
  close: string;
  archive: string;
  delete: string;

  // 确认对话框
  confirmDelete: string;
  confirmArchive: string;
  deleteCannotUndo: string;
  archiveCanFind: string;

  // 归档标签页
  chats: string;
  archived: string;
  restore: string;
  noArchivedChats: string;
  backToChats: string;

  // 资源面板
  resources: string;
  addResource: string;
  deleteResource: string;
  noMatchingResourcesFound: string;
  noResourcesAvailable: string;
  hideResources: string;
  showResources: string;
  closeResourcesPanel: string;

  // 上传状态
  uploading: string;
  processing: string;
  uploadSuccess: string;
  uploadError: string;

  // 聊天输入框
  typeMessage: string;
  thinkingOptions: string;
  deleteFile: string;
  clearSelection: string;
  addAttachment: string;
  sendMessage: string;
  cancelRequest: string;

  // 思考模式选项
  quickAnswer: string;
  quickAnswerDesc: string;
  deepInsight: string;
  deepInsightDesc: string;
  deepExploration: string;
  deepExplorationDesc: string;
  deepDeconstruction: string;
  deepDeconstructionDesc: string;

  // 写作模式选项
  contractReview: string;
  contractReviewDesc: string;
  textPolish: string;
  textPolishDesc: string;
  legalDocuments: string;
  legalDocumentsDesc: string;

  // 认证相关
  login: string;
  register: string;
  welcomeBack: string;
  loginSubtitle: string;
  continueWithGoogle: string;
  continueWithMicrosoft: string;
  continueWithWeChat: string;
  orContinueWith: string;
  emailTab: string;
  phoneTab: string;
  emailPlaceholder: string;
  phonePlaceholder: string;
  codePlaceholder: string;
  sending: string;
  verifying: string;
  verify: string;
  sendMagicLink: string;
  getVerificationCode: string;
  resendCode: string;
  resendIn: string;
  magicLinkSent: string;
  magicLinkHint: string;
  otpSent: string;
  agreeToTerms: string;
  privacyPolicy: string;
  termsOfService: string;
  and: string;

  // AI工具面板
  library: string;
  aiReview: string;
  aiDraft: string;
  smartAssistant: string;
  // templateFill: string; // Deprecated
  // formFill: string; // Deprecated

  // 知识库搜索
  enableKnowledgeSearch: string;
  knowledgeSearchDesc: string;
  clickToDisable: string;
  clickToEnable: string;

  // 隐私相关
  privacyTitle: string;
  privacyIntro: string;
  essentialCookies: string;
  essentialDesc: string;
  analyticsCookies: string;
  analyticsDesc: string;
  marketingCookies: string;
  marketingDesc: string;
  acceptAll: string;
  essentialOnly: string;
  customize: string;
  savePreferences: string;
  back: string;
  readPrivacyPolicy: string;
  cookiePolicy: string;
  gdprCompliance: string;
  piplCompliance: string;

  // 工具历史筛选
  filterAll: string;
  filterChat: string;
  filterReview: string;
  filterDraft: string;
  filterTemplate: string;
  filterForm: string;

  // AI 思考状态
  thinking: string;
  thinkingProcess: string;
  analyzingLegalLogic: string;
  lawhelperThinking: string;
  serviceError: string;
  uploaded: string;

  // AI Reviewer
  reviewTitle: string;
  exitReview: string;
  uploadPrompt: string;
  uploadButton: string;
  startChatConfig: string;
  reviewPlaceholder: string;
  analyzing: string;
  reviewComplete: string;
  issuesFound: string;

  // AI Drafter
  draftTitle: string;
  draftPlaceholder: string;
  analyzingTemplate: string;
  templateAnalyzed: string;
  templateAnalysisPrompt: string;
  parsingFailed: string;
  generating: string;
  generatedSuccess: string;

  // AI Drafter Welcome Section
  drafterWelcome: string;
  drafterYouCan: string;
  drafterUploadTemplate: string;
  drafterDescribeNeeds: string;
  drafterLetAiHelp: string;
  drafterExamples: string;
  drafterExampleRental: string;
  drafterExampleLabor: string;
  drafterInputPlaceholder: string;
  drafterThinking: string;
  drafterHistoryTitle: string;
  drafterNoHistory: string;
  drafterNewChat: string;
  drafterHistory: string;
  drafterRemoveAttachment: string;
  drafterLineHeight: string;
  drafterLineHeightSuffix: string;
  drafterExportWord: string;
  drafterExportPdf: string;
  drafterSave: string;
  drafterDownload: string;
  drafterUndo: string;
  drafterRedo: string;
  drafterBold: string;
  drafterItalic: string;
  drafterStrike: string;
  drafterUnderline: string;
  drafterHighlight: string;
  drafterLink: string;
  drafterAlignLeft: string;
  drafterAlignCenter: string;
  drafterAlignRight: string;
  drafterAlignJustify: string;
  drafterList: string;
  drafterBulletList: string;
  drafterOrderedList: string;
  drafterTaskList: string;
  drafterOpenResource: string;
  drafterStopGeneration: string;
  drafterAgentMode: string;
  drafterAgentModeOn: string;
  drafterAgentModeOff: string;
  drafterUploadAttachment: string;
  drafterExit: string;
  drafterConfirm: string;
  drafterOpenLink: string;
  drafterDeleteLink: string;
  drafterQuote: string;

  // 设置页面
  settingsGeneral: string;
  settingsNotifications: string;
  settingsAppearance: string;
  settingsProfile: string;
  settingsResponseNotifications: string;
  settingsResponseNotificationsDesc: string;
  settingsColorMode: string;
  settingsLight: string;
  settingsDark: string;
  settingsSystem: string;

  // New
  about: string;

  // Workflow UI
  workflowTitle: string;
  workflowRunning: string;
  workflowReady: string;
  workflowCompleted: string;
  workflowStartFailed: string;
  workflowExecutionFailed: string;
  workflowInterrupted: string;
  workflowProcessing: string;
  workflowStepsCompleted: string;
  workflowStepsTotal: string;

  // Workflow Actions
  acceptChanges: string;
  rejectChanges: string;
  changesAccepted: string;
  changesRejected: string;
  stopWorkflow: string;
  restartWorkflow: string;
  startDrafting: string;
  interrupt: string;

  // Workflow Form Labels
  documentSubject: string;
  documentType: string;
  jurisdiction: string;
  specialRequirements: string;
  clickStartDrafting: string;

  // Document Types
  docTypeContract: string;
  docTypeAgreement: string;
  docTypeNotice: string;
  docTypeLetter: string;
  docTypePetition: string;
  docTypeWill: string;
  docTypePowerOfAttorney: string;

  // Countries
  countryChina: string;
  countryUSA: string;
  countryGermany: string;
  countryJapan: string;
  countryFrance: string;
  countryUK: string;

  // Citation Verification
  citationVerified: string;
  citationUnverified: string;

  // Image Loading
  imageLoadFailed: string;

  // Smart Document Assistant
  smartDocTitle: string;
  smartDocChatTitle: string;
  smartDocDropPrompt: string;
  smartDocSelectFile: string;
  smartDocOr: string;
  smartDocWelcomeTitle: string;
  smartDocWelcomeYouCan: string;
  smartDocUploadForAI: string;
  smartDocDescribeDoc: string;
  smartDocLetAIDraft: string;
  smartDocExamples: string;
  smartDocExampleRental: string;
  smartDocExampleLabor: string;
  smartDocInputPlaceholder: string;
  smartDocRemoveAttachment: string;
  smartDocOpenResources: string;
  smartDocExit: string;

  // Review Workflow
  reviewStartFailed: string;
  reviewFailed: string;
  reviewFoundIssues: string;
  cannotReadStream: string;
  parseEventFailed: string;
  errorPrefix: string;
  // Common Terms
  file: string;
  loading: string;
  unknownError: string;

  // Landing page translations
  tagline: string;
  heroTitle1: string;
  heroTitle2: string;
  jurisdictionsLabel: string;
  accuracyLabel: string;
  fasterLabel: string;
  availableLabel: string;
  platformCapabilities: string;
  testimonialQuote: string;
  testimonialAuthor: string;
  testimonialPosition: string;
  viewPricing: string;
  footerPricing: string;
  footerPrivacy: string;
  footerTerms: string;
  footerContact: string;
  footerCopyright: string;

  // Local Folder Browser
  localFolders: string;
  selectLocalFolder: string;
  reselectFolder: string;
  addToContext: string;
  saveFile: string;
  renameFile: string;
  fileSaved: string;
  fileRenamed: string;
  browserNotSupported: string;
  noFolderSelected: string;
  scanningFolder: string;
  selectFileToPreview: string;
  aiAnalyze: string;

  // Onboarding Guide
  onboardingWelcome: string;
  onboardingSkip: string;
  onboardingNext: string;
  onboardingPrev: string;
  onboardingGetStarted: string;
  onboardingSlide1Title: string;
  onboardingSlide1Desc: string;
  onboardingSlide2Title: string;
  onboardingSlide2Desc: string;
  onboardingSlide3Title: string;
  onboardingSlide3Desc: string;
  onboardingSlide4Title: string;
  onboardingSlide4Desc: string;
  onboardingGuide: string;

  // @ Mention
  mentionFiles: string;
}

// 允许部分翻译的类型
export type PartialTranslation = Partial<Translation>;

export const translations: Record<string, PartialTranslation> = allTranslations;

// 获取翻译文本的函数
export const getTranslation = (languageCode: string, key: keyof Translation): string => {
  // 如果是自动检测，使用检测到的语言
  if (languageCode === 'auto') {
    // 使用detectSystemLanguage函数进行检测
    const detected = detectSystemLanguage();
    languageCode = detected;
  }

  // 特殊处理：品牌名称在所有语言中都应该相同
  if (key === 'lawhelperAi') {
    return 'Lawhelper.ai';
  }

  // 尝试精确匹配
  if (translations[languageCode]) {
    const translation = translations[languageCode][key];
    if (translation) {
      return translation;
    }
  }

  // 尝试语言代码匹配 (例如: en-US -> en)
  const langCode = languageCode.split('-')[0];
  const matchingLang = Object.keys(translations).find(k => k.startsWith(langCode));
  if (matchingLang && translations[matchingLang]) {
    const translation = translations[matchingLang][key];
    if (translation) {
      return translation;
    }
  }

  // 如果找不到翻译，返回英语默认值
  if (translations['en-US'] && translations['en-US'][key]) {
    return translations['en-US'][key] as string;
  }

  // 最后的fallback
  return `[${languageCode}] ${key}`;
};
